import * as React from "react";

const padBreakPoint = 769; // 大於768防止設備偵測邊界誤差
const phoneBreakPoint = 431; // 大於430防止設備偵測邊界誤差

export function useIsMobile(type?: "pad" | "phone") {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined
  );

  React.useEffect(() => {
    let breakPoint: number;
    if (type === "pad") {
      breakPoint = padBreakPoint;
    } else if (type === "phone") {
      breakPoint = phoneBreakPoint;
    } else {
      breakPoint = padBreakPoint;
    }
    const mql = window.matchMedia(`(max-width: ${breakPoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < breakPoint);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < breakPoint);
    return () => mql.removeEventListener("change", onChange);
  }, [type]);

  return !!isMobile;
}
